import crud from "./_crud";

const actions = crud('merchandise_type', 'el tipo de mercancia', 'los tipos de mercancía');

export default actions